import { render } from "./DisclaimerModal.vue?vue&type=template&id=43d280fe&scoped=true"
import script from "./DisclaimerModal.vue?vue&type=script&lang=js"
export * from "./DisclaimerModal.vue?vue&type=script&lang=js"

import "./DisclaimerModal.vue?vue&type=style&index=0&id=43d280fe&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d280fe"]])

export default __exports__